import { Avatar, Divider, RichTextReader, Stack, Typography } from "@compass/core";

import { Comment2 } from "generated/openApi";
import { useDateTime } from "hooks";

export const ManageComments = (props: { comments: Comment2[] | undefined }) => {
  const formatDateTime = useDateTime();

  return (
    <Stack direction="column" spacing="md">
      <Stack direction="column">
        {props.comments?.map((comment) => (
          <Stack key={comment.id} direction="column" py={2}>
            <Stack direction="row" justifyContent={"space-between"} alignItems="center">
              <Stack direction="row" spacing="md" alignItems="center">
                {comment.createdByName && <Avatar string={comment.createdByName} />}

                <Stack direction="column">
                  <Typography fontWeight={"medium"}>{comment.createdByName}</Typography>

                  <Typography variant="caption">{formatDateTime(comment.createdDate)}</Typography>
                </Stack>
              </Stack>
            </Stack>

            <Stack direction="column" spacing="md" px={3} py={2}>
              <RichTextReader html={comment.message} />
            </Stack>

            <Divider />
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
};
